<template>
    <div
        class="hidden md:flex side-info p-6 bg-white rounded flex-col justify-start items-start gap-6">
        <div
            class="self-stretch justify-between items-start inline-flex w-full">
            <div class="flex-col justify-start items-start gap-2 inline-flex">
                <div
                    class="text-neutral-900 text-base font-bold font-Open-Bold">
                    {{ formatDate(state.selected_date) }}
                </div>
                <div
                    class="h-7 text-neutral-900 text-sm font-normal font-Open leading-tight">
                    {{ dynamicTime.start_time }} - {{ dynamicTime.end_time }}
                </div>
            </div>
            <div class="justify-end items-end flex pt-1">
                <NuxtLink
                    to="/date"
                    class="action-btn edit-booking">
                    <div
                        class="text-indigo-600 text-sm font-normal font-Open underline leading-tight">
                        Edit
                    </div>
                </NuxtLink>
            </div>
        </div>

        <div
            class="self-stretch bg-white flex-col justify-center items-center gap-4 flex">
            <div
                class="self-stretch h-5 flex-col justify-start items-start gap-2 flex">
                <div
                    class="self-stretch justify-start items-center gap-2 inline-flex">
                    <div
                        class="grow shrink basis-0 h-5 justify-start items-center gap-2 flex">
                        <Icon
                            class="mr-2"
                            icon="up-logo-icon"
                            alt="U.P Location Icon" />
                        <div
                            class="grow shrink basis-0 self-stretch text-neutral-900 text-sm font-normal font-Open leading-[24px]">
                            {{ state.display_name }}
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="!bookingStore.state.is_online"
                class="self-stretch justify-start items-start gap-2 inline-flex">
                <div
                    class="grow shrink basis-0 self-stretch text-neutral-900 text-sm font-normal font-Open underline leading-[24px]">
                    <a
                        :href="state.maps_url"
                        target="_blank">
                        <div class="flex w-full cursor-pointer">
                            <Icon
                                class="mr-4"
                                icon="location-marker"
                                alt="U.P Location Icon (Clock)" />
                            <div>
                                <span class="location-address cursor-pointer">{{
                                    formattedAddress
                                }}</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div
                class="self-stretch justify-start items-start gap-2 inline-flex">
                <Icon
                    class="mr-2"
                    icon="video"
                    alt="Video Icon"
                    v-if="bookingStore.state.is_online" />
                <Icon
                    class="mr-2"
                    icon="user"
                    alt="User Icon"
                    v-else />
                <div
                    class="grow shrink basis-0 self-stretch text-neutral-900 text-sm font-normal font-Open leading-[24px]">
                    <div
                        v-if="bookingStore.state.is_online"
                        class="text-highlight">
                        Virtual consultation
                    </div>
                    <div v-else>In-Person consultation</div>
                </div>
            </div>
            <div
                class="self-stretch justify-start items-start gap-2 inline-flex">
                <Icon
                    class="mr-2"
                    icon="clock"
                    alt="U.P Location Icon (Clock)" />
                <div
                    class="grow shrink basis-0 self-stretch text-neutral-900 text-sm font-normal font-Open leading-[24px]">
                    {{ convertAzureTime(state.duration).minutes }}
                    minutes consultation
                </div>
            </div>
            <div
                class="grow shrink basis-0 mr-6 self-stretch flex-col justify-center items-start inline-flex"
                v-show="is_online_checkbox.show">
                <label
                    :for="is_online_checkbox.name"
                    :class="[
                        'self-stretch justify-start items-start gap-2 inline-flex cursor-pointer relative text-neutral-900 text-sm font-normal font-Open',
                    ]">
                    <input
                        type="checkbox"
                        :value="is_online_checkbox.name"
                        :name="is_online_checkbox.name"
                        @change="
                            handleCheckboxChange(
                                $event,
                                is_online_checkbox.name
                            )
                        "
                        :checked="is_online_checkbox.checked"
                        class="opacity-0 top-0 bottom-0 right-0 left-0 block absolute width-full height-full z-20 cursor-pointer" />

                    <div class="is-online-checkbox mr-2"></div>
                    Make this a virtual consultation?
                </label>
            </div>
            <div
                class="grow shrink basis-0 mr-6 self-stretch flex-col justify-center items-start inline-flex"
                v-show="signup_fee_paid_checkbox.show">
                <label
                    :for="signup_fee_paid_checkbox.name"
                    :class="[
                        'self-stretch justify-start items-start gap-2 inline-flex cursor-pointer relative text-neutral-900 text-sm font-normal font-Open',
                    ]">
                    <input
                        type="checkbox"
                        :value="signup_fee_paid_checkbox.name"
                        :name="signup_fee_paid_checkbox.name"
                        @change="
                            handleCheckboxChange(
                                $event,
                                signup_fee_paid_checkbox.name
                            )
                        "
                        :checked="signup_fee_paid_checkbox.checked"
                        class="opacity-0 top-0 bottom-0 right-0 left-0 block absolute width-full height-full z-20 cursor-pointer" />

                    <div class="signup-fee-paid-checkbox mr-2"></div>
                    Has the signup fee been paid?
                </label>
            </div>
        </div>

        <div class="flex-col justify-start items-start gap-4 flex">
            <div
                class="self-stretch flex-col justify-start items-start gap-2 flex">
                <div
                    class="self-stretch flex-col justify-start items-start gap-2 flex">
                    <div
                        class="text-neutral-900 text-base font-bold font-Open-Bold">
                        What to expect:
                    </div>
                </div>
                <div
                    class="self-stretch text-zinc-800 text-base font-normal font-Open leading-normal">
                    Finding your U.P gym: We recommend planning your visit to
                    U.P. ahead of time. Information about how to find us, nearby
                    parking, and convenient transport options can be found on
                    our website. A member of our team will be there to meet and
                    greet you upon arrival.
                </div>
            </div>
        </div>

        <div class="flex-col justify-start items-start gap-4 flex">
            <div
                class="self-stretch flex-col justify-start items-start gap-2 flex">
                <div
                    class="self-stretch flex-col justify-start items-start gap-2 flex">
                    <div
                        class="text-neutral-900 text-base font-bold font-Open-Bold">
                        What to expect during the consultation:
                    </div>
                </div>
                <div
                    class="self-stretch text-zinc-800 text-base font-normal font-Open leading-normal">
                    You'll have a 30-minute conversation with a member of our
                    training team in our private consultation room. It’s your
                    opportunity to discuss your personal goals, understand how
                    the process works, and see how we tailor our method to you.
                    You can explore the best package for you, ask any questions,
                    and take a tour of the gym facilities.
                </div>
            </div>
        </div>

        <div class="flex-col justify-start items-start gap-4 flex">
            <div
                class="self-stretch flex-col justify-start items-start gap-2 flex">
                <div
                    class="self-stretch flex-col justify-start items-start gap-2 flex">
                    <div
                        class="text-neutral-900 text-base font-bold font-Open-Bold">
                        What to bring:
                    </div>
                </div>
                <div
                    class="self-stretch text-zinc-800 text-base font-normal font-Open leading-normal">
                    You don’t need to bring any gym clothing with you for your
                    consultation. Please feel free to come along in your regular
                    clothing.
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { convertAzureTime } from '@/helpers/azureDateTimeFormats';
    import { formatDate, convertTo12Hour } from '@/helpers/dateFormats';
    import { useStateStore } from '@/stores/state';
    import { useBookingStore } from '@/stores/booking';

    import { formatAddress } from '@/helpers/formatAddress';

    defineProps({
        is_online_checkbox: Object,
        signup_fee_paid_checkbox: Object,
    });

    const bookingStore = useBookingStore();
    const { state, updateBookingState } = bookingStore;
    const formattedAddress = computed(() => formatAddress(bookingStore.state.address));

    const { state: applicationState } = useStateStore();
    const dynamicTime = computed(() => {
        const times = applicationState.is24HourFormat
            ? {
                  start_time: state.start_time,
                  end_time: state.end_time,
              }
            : {
                  start_time: convertTo12Hour(state.start_time),
                  end_time: convertTo12Hour(state.end_time),
              };

        return times;
    });

    const handleCheckboxChange = (event, itemName) => {
        const { checked } = event.target;
        updateBookingState({ [itemName]: checked });
    };
</script>
